const baseUrl = 'https://appoint-doctor.onrender.com/';
export default baseUrl;
